import { bind } from 'decko'
import { LiveElement } from 'live-node-list'

export default class Login {
  /**
   * @type {LiveElement}
   */
  templateLogin = new LiveElement('.template-customers-login')

  /**
   * @type {LiveElement}
   */
  recoverPasswordForm = new LiveElement('#RecoverPasswordForm')

  /**
   * @type {LiveElement}
   */
  recoverPasswordFormLink = new LiveElement('#RecoverPassword')

  /**
   * @type {LiveElement}
   */
  customerLoginForm = new LiveElement('#CustomerLoginForm')

  /**
   * @type {LiveElement}
   */
  hideRecoverPasswordLink = new LiveElement('#HideRecoverPasswordLink')

  /**
   * @type {LiveElement}
   */
  resetSuccess = new LiveElement('#ResetSuccess')

  constructor() {
    this.registerListeners()
  }

  @bind
  registerListeners() {
    this.recoverPasswordFormLink.addEventListener(
      'click',
      this.toggleRecoverPasswordForm
    )

    this.hideRecoverPasswordLink.addEventListener('click', e => {
      const hash = window.location.hash
      if (hash === '#recover') {
        window.location.href.split('#')[0]
      }
      this.toggleRecoverPasswordForm()
    })

    this.onLoad()
    document.addEventListener('DOMContentLoaded', this.onLoad)
    this.templateLogin.on('update', this.onLoad)

    this.resetPasswordSuccess()
  }

  @bind
  onLoad() {
    if (!this.templateLogin.item) {
      return
    }

    const hash = window.location.hash

    if (hash === '#recover') {
      this.showRecoverPasswordForm()
    }
  }

  showHidePasswordForm(e) {
    e.preventDefault()
    this.toggleRecoverPasswordForm()
  }

  /**
   * Show/Hide recover password form
   */
  @bind
  toggleRecoverPasswordForm() {
    if (!this.recoverPasswordForm.item) {
      return
    }

    this.recoverPasswordForm.item.classList.toggle('hide')
    this.customerLoginForm.item.classList.toggle('hide')
  }

  /**
   * Show/Hide recover password form
   */
  @bind
  showRecoverPasswordForm() {
    if (!this.recoverPasswordForm.item) {
      return
    }

    this.recoverPasswordForm.item.classList.remove('hide')
    this.customerLoginForm.item.classList.add('hide')
  }

  @bind
  resetPasswordSuccess() {
    if (!this.templateLogin.item) {
      return
    }

    this.formState = this.templateLogin.item.querySelector(
      '.reset-password-success'
    )

    if (!this.formState) {
      return
    }

    this.resetSuccess.item.classList.remove('hide')
  }
}
